import { STRINGS, NUMBERS } from "@/interfaces/SmartLink/General";

const zonaMultiple = [
  {
    value: -100,
    color: "#7cb5ec",
  },
  {
    value: -90,
    color: "#e69a5c",
  },
  {
    value: -1.1,
    color: "#e3272a",
  },
  {
    color: "#000000",
  },
];

interface Zone {
  value?: number;
  color: string;
}
interface Zones {
  [key: string]: Zone[];
}

const ZONES: Zones = {
  Latency: [
    {
      value: 0,
      color: "#000000",
    },
    {
      value: 100,
      color: "#eecaca",
    },
    {
      color: "#FF3333",
    },
  ],
  Reset: [
    {
      value: 0,
      color: "#000000",
    },
    {
      value: 500,
      color: "#eecaca",
    },
    {
      color: "#FF3333",
    },
  ],
  snmp: [
    {
      value: -75,
      color: "#FF6961",
    },
    {
      value: -65,
      color: "#FDFD96",
    },
    {
      color: "#06CB03",
    },
  ],
  wlan0noise: zonaMultiple,
  wlan1noise: zonaMultiple,
  wlan2noise: zonaMultiple,
  wlan3noise: zonaMultiple,
  Status: [
    {
      value: 1,
      color: "#5a5b5e",
    },
    {
      value: 2,
      color: "#ea9999",
    },
    {
      value: 3,
      color: "#ffd966",
    },
    {
      value: 4,
      color: "#93c47d",
    },
  ],
  temperature: [
    {
      value: 30,
      color: "#06CB03",
    },
    {
      value: 60,
      color: "#d8fd30",
    },
    {
      value: 70,
      color: "#ff9a02",
    },
    {
      color: "#CB0F03",
    },
  ],
  PRG: [
    {
      value: 20,
      color: "#031BCB",
    },
    {
      value: 58,
      color: "#06CB03",
    },
    {
      color: "#CB0F03",
    },
  ],
  LX5: [
    {
      value: 18,
      color: "#031BCB",
    },
    {
      value: 45,
      color: "#06CB03",
    },
    {
      color: "#CB0F03",
    },
  ],
  OSP: [
    {
      value: 9,
      color: "#031BCB",
    },
    {
      value: 28,
      color: "#06CB03",
    },
    {
      color: "#CB0F03",
    },
  ],
  JR3: [
    {
      value: 9,
      color: "#031BCB",
    },
    {
      value: 28,
      color: "#06CB03",
    },
    {
      color: "#CB0F03",
    },
  ],
  HNT: [
    {
      value: 8,
      color: "#031BCB",
    },
    {
      value: 45,
      color: "#06CB03",
    },
    {
      color: "#CB0F03",
    },
  ],
  Cost: [
    {
      value: 5000,
      color: "#22FB00",
    },
    {
      value: 10000,
      color: "#F7FB00",
    },
    {
      color: "#FB0B00",
    },
  ],
  predictsnr: [
    {
      value: 20,
      color: "#FA1717",
    },
  ],
  predict: [
    {
      value: -75,
      color: "#FA1717",
    },
  ],
};

const POTLINE: NUMBERS = {
  Latency: 100,
  PRG: 58,
  LX5: 45,
  JR3: 28,
  OSP: 28,
  HNT: 45,
  predict: -75,
  snmp2: -65,
  predictsnr: 20,
  "Predict vs Real": -70,
};

const TYPE_GRAPH: STRINGS = {
  Status: "column",
  Voltage: "column",
  temperature: "column",
  Cost: "column",
  rssi: "column",
  rsrp: "column",
  rsrq: "column",
};

const YAXISLABEL: STRINGS = {
  Reset: "Milliseconds",
  Latency: "Milliseconds",
  wlan0noise: "dBm",
  wlan1noise: "dBm",
  wlan2noise: "dBm",
  wlan3noise: "dBm",
  cpu: "%",
  memoria: "%",
  disco: "%",
  predict: "dBm",
  instamesh: "GB",
  temperature: "°C",
  Voltage: "Volt",
  throughput: "Gbps",
  SNRHorizontal: "dB",
  SNRVertical: "dB",
  RXHorizontal: "dBm",
  RXVertical: "dBm",
};

import { COLOR } from "./colors";

export const ZONE_GRAPHS: any = {
  status: [
    { value: 1, color: COLOR.greyfake },
    { value: 2, color: COLOR.red },
    { value: 3, color: COLOR.yellow },
    { value: 4, color: COLOR.green },
  ],
  Reset: [
    { value: 0, color: COLOR.grey },
    { value: 100, color: COLOR.green },
    { value: 500, color: COLOR.yellow },
    { color: COLOR.red },
  ],
  Latencia: [
    { value: 0, color: COLOR.grey },
    { value: 100, color: COLOR.green },
    { value: 500, color: COLOR.yellow },
    { color: COLOR.red },
  ],
};

export const CONST_SENSORES: any = {
  "ES1-2450RE": 0,
  "FE1-2255B": 3,
  "FE1-2450": 3,
  "FE1-2455LW": 3,
  "JR3-52": 0,
  "LX5-2255C": 0,
  "ME4-2450RE2": 0,
  "ME5-2450CS": 0,
  "FE1-2450A": 3,
  "FE1-2455LS": 3,
};

export default {
  ZONES,
  YAXISLABEL,
  POTLINE,
  TYPE_GRAPH,
};
